// Typed path constants — single source of truth for routes.
// Functions take the same slug/id types the URL would carry and return the resolved path.

export const paths = {
  root: '/',
  home: '/',

  about: '/about',
  methodology: '/methodology',
  contact: '/contact',

  legal: {
    privacy: '/legal/privacy',
    terms: '/legal/terms',
  },

  gems: {
    all: '/gems',
    detail: (slug: string) => `/gems/${slug}`,
    conversation: (slug: string, conversationId: string) => `/gems/${slug}/c/${conversationId}`,
  },

  chat: {
    root: '/c',
    conversation: (conversationId: string) => `/c/${conversationId}`,
  },

  share: {
    view: (id: string) => `/share/${id}`,
  },

  auth: {
    login: '/auth/login',
    register: '/auth/register',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
    verifyEmail: '/auth/verify-email',
  },

  settings: {
    account: '/settings/account',
    preferences: '/settings/preferences',
    notifications: '/settings/notifications',
    privacy: '/settings/privacy',
  },
} as const;
